import { ROOT_URL_HOST } from '@/shared/constants/contactConstants';

export type SchemaNode = Record<string, unknown>;

export interface SchemaBreadcrumb {
  name: string;
  url?: string;
}

export const SCHEMA_LANGUAGE: string = 'ru-RU';
export const SCHEMA_COUNTRY_CODE: string = 'RU';
export const SCHEMA_TEXT_MAX_LENGTH: number = 300;

export const ORGANIZATION_SCHEMA_ID: string = `${ROOT_URL_HOST}/#organization`;
export const WEBSITE_SCHEMA_ID: string = `${ROOT_URL_HOST}/#website`;

export const organizationReference: SchemaNode = { '@id': ORGANIZATION_SCHEMA_ID };
export const websiteReference: SchemaNode = { '@id': WEBSITE_SCHEMA_ID };
export const countryNode: SchemaNode = { '@type': 'Country', name: 'Россия' };

export const buildAbsoluteUrl = (path: string): string => {
  const [cleanPath = ''] = path.split(/[?#]/);
  return `${ROOT_URL_HOST}${cleanPath.startsWith('/') ? cleanPath : `/${cleanPath}`}`;
};

export const buildPageId = (pageUrl: string): string => `${pageUrl}#webpage`;
export const buildBreadcrumbId = (pageUrl: string): string => `${pageUrl}#breadcrumb`;
export const buildListId = (pageUrl: string): string => `${pageUrl}#list`;
export const buildPersonId = (profileUrl: string): string => `${profileUrl}#person`;
export const buildServiceId = (profileUrl: string): string => `${profileUrl}#service`;

export const buildCityNode = (name: string): SchemaNode => ({ '@type': 'City', name });

export const buildPostalAddress = (address: {
  street?: string;
  locality?: string;
}): SchemaNode => ({
  '@type': 'PostalAddress',
  ...(address.street ? { streetAddress: address.street } : {}),
  ...(address.locality ? { addressLocality: address.locality } : {}),
  addressCountry: SCHEMA_COUNTRY_CODE,
});

export const buildBreadcrumbListNode = (
  pageUrl: string,
  items: SchemaBreadcrumb[],
): SchemaNode => ({
  '@type': 'BreadcrumbList',
  '@id': buildBreadcrumbId(pageUrl),
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    ...(index < items.length - 1 && item.url ? { item: buildAbsoluteUrl(item.url) } : {}),
  })),
});

const HTML_TAG_PATTERN = /<[^>]*>/g;
const TRAILING_PUNCTUATION_PATTERN = /[\s,;:—-]+$/;

export const buildSchemaText = (
  text: string,
  maxLength: number = SCHEMA_TEXT_MAX_LENGTH,
): string => {
  const clean = text
    .replace(HTML_TAG_PATTERN, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  if (clean.length <= maxLength) return clean;

  const cut = clean.slice(0, maxLength);
  const lastSpace = cut.lastIndexOf(' ');
  return (lastSpace > 0 ? cut.slice(0, lastSpace) : cut).replace(
    TRAILING_PUNCTUATION_PATTERN,
    '',
  );
};
